module.exports = __webpack_public_path__ + "static/media/tap_stop_img.a622d4e7.png";